import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Select, FormInstance } from "antd";
interface ResetPasswordFormProps {
  form: FormInstance<any>
}
const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ form }) => {

  return (
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
      <div style={{ marginTop: "20px" }}></div>
      <Form.Item label="Mật khẩu mới" name="newPassword"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống mật khẩu",
          },
          { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự!" },
        ]}
      >
        <Input.Password />
      </Form.Item>
    </Form>
  );
};

export default ResetPasswordForm;
